<app-modal-header [title]="title"></app-modal-header>
<div class="modal-body pt-4 pt-0">
    <app-input-box [(inputModel)]="assignmentData.name" [label]="assignmentData.name">
    </app-input-box>
    <div class="actions d-flex flex-wrap flex-sm-nowrap justify-content-end">
        <button
            (click)="activeModal.dismiss('Confirm Save'); saveCallback(assignmentData)"
            class="btn px-7 py-4 btn-primary w-100 w-sm-auto mt-4"
            type="button"
        >
            Save to Awaiting Assignment
        </button>
        <button
            (click)="activeModal.dismiss('Confirm Assign'); assignCallback(assignmentData)"
            class="btn px-7 py-4 btn-primary ms-sm-4 w-100 w-sm-auto mt-4"
            type="button"
        >
            I'm ready to assign this
        </button>
    </div>
</div>
